import { handleGaTracking } from "../utils/js/tracking";

class TPL_Transverse_Loyalty {
  constructor(componentHost) {
    this.componentHost = componentHost;

    this.mainWrapper = this.componentHost.querySelector(".loyalty");

    if (!this.mainWrapper) return;

    this.initEvents();
  }

  initEvents() {
    this.cellB398();
  }

  cellB398() {
    const links = this.mainWrapper.querySelectorAll(".ace-button a");

    const enrollElement = Array.from(links)?.find((link) =>
      link.href.includes("enroll-loyalty"),
    );

    if (!enrollElement) return;

    handleGaTracking({
      node: enrollElement,
      eventName: "cta_enroll",
      additionalData: {
        enroll_context: "loyalty",
        cta_name: "become a member",
      },
    });
  }
}

new TPL_Transverse_Loyalty(document.body);
